
import { Component, Directive, OnInit, ViewEncapsulation, OnDestroy, Inject, forwardRef } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	templateUrl: './NoticiasParent.component.html'
})

export class NoticiasParentComponent implements OnInit {

	constructor(
		private router: Router
	) {
		console.log('*** NoticiasParentComponent ***');
	}

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Noticias/NoticiasParent.component.ts